/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import DashboardStatsClearanceCompliance from './DashboardStatsClearanceCompliance';
import DashboardStatsSurgeriesThisWeek from './DashboardStatsSurgeriesThisWeek';

/**
 * The DashboardStats model module.
 * @module model/DashboardStats
 * @version v0.3
 */
export default class DashboardStats {
  /**
   * Constructs a new <code>DashboardStats</code>.
   * @alias module:model/DashboardStats
   * @class
   * @param surgeriesThisWeek {module:model/DashboardStatsSurgeriesThisWeek}
   * @param highRiskPatients {Number}
   * @param avgLeadTime {Number}
   * @param pendingEnrollment {Number}
   * @param clearanceCompliance {module:model/DashboardStatsClearanceCompliance}
   * @param prepCompliance {module:model/DashboardStatsClearanceCompliance}
   */
  constructor(surgeriesThisWeek, highRiskPatients, avgLeadTime, pendingEnrollment, clearanceCompliance, prepCompliance) {
    this.surgeriesThisWeek = surgeriesThisWeek;
    this.highRiskPatients = highRiskPatients;
    this.avgLeadTime = avgLeadTime;
    this.pendingEnrollment = pendingEnrollment;
    this.clearanceCompliance = clearanceCompliance;
    this.prepCompliance = prepCompliance;
  }

  /**
   * Constructs a <code>DashboardStats</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardStats} obj Optional instance to populate.
   * @return {module:model/DashboardStats} The populated <code>DashboardStats</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DashboardStats();
      if (data.hasOwnProperty('surgeries_this_week'))
        obj.surgeriesThisWeek = DashboardStatsSurgeriesThisWeek.constructFromObject(data['surgeries_this_week']);
      if (data.hasOwnProperty('high_risk_patients'))
        obj.highRiskPatients = ApiClient.convertToType(data['high_risk_patients'], 'Number');
      if (data.hasOwnProperty('avg_lead_time'))
        obj.avgLeadTime = ApiClient.convertToType(data['avg_lead_time'], 'Number');
      if (data.hasOwnProperty('pending_enrollment'))
        obj.pendingEnrollment = ApiClient.convertToType(data['pending_enrollment'], 'Number');
      if (data.hasOwnProperty('clearance_compliance'))
        obj.clearanceCompliance = DashboardStatsClearanceCompliance.constructFromObject(data['clearance_compliance']);
      if (data.hasOwnProperty('prep_compliance'))
        obj.prepCompliance = DashboardStatsClearanceCompliance.constructFromObject(data['prep_compliance']);
    }
    return obj;
  }
}

/**
 * @member {module:model/DashboardStatsSurgeriesThisWeek} surgeriesThisWeek
 */
DashboardStats.prototype.surgeriesThisWeek = undefined;

/**
 * @member {Number} highRiskPatients
 */
DashboardStats.prototype.highRiskPatients = undefined;

/**
 * @member {Number} avgLeadTime
 */
DashboardStats.prototype.avgLeadTime = undefined;

/**
 * @member {Number} pendingEnrollment
 */
DashboardStats.prototype.pendingEnrollment = undefined;

/**
 * @member {module:model/DashboardStatsClearanceCompliance} clearanceCompliance
 */
DashboardStats.prototype.clearanceCompliance = undefined;

/**
 * @member {module:model/DashboardStatsClearanceCompliance} prepCompliance
 */
DashboardStats.prototype.prepCompliance = undefined;
